var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      (_vm.institution && !_vm.institution.kl_assessment) ||
      (_vm.user && _vm.user.group_names.includes('ESTUDIANTES')) ||
      (_vm.user && _vm.user.group_names.includes('PROFESORES'))
    )?[_c('Page404')]:[_c('NavigationBreadcrumb',{attrs:{"items":_vm.breadcrumb_items}}),_c('h3',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.$getVisibleNames( "manual.administrar_seccion", true, "Administrar Secciones" ))+" "),_c('AlternativeNameButton',{attrs:{"table_name":'manual.administrar_seccion',"allows_crud":_vm.allows_crud}})],1),_c('div',{staticClass:"mt-5 mb-3 mx-2"},[_c('SectionList',{attrs:{"allows_crud":_vm.allows_crud}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }